import {ChangeDetectorRef, Component, Input, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {TableInputConfig} from "../../../shared/components/inputs/table-input/table-input.component";
import {FileDto} from "../../../models/file";
import {ComparableOperator, Form, FormQuestionGroups, GroupOp, PosibleAnswer} from "../../../models/form";

import {ConfigsLoaderService} from "../../../services/config-loader.service";
import {QUESTION_TYPES, QuestionData, QuestionParameters} from "../form-question.directive";
import { createMockAnswers, createMockForm, createMockPosibleAnswes, createMockTableConfig } from 'assets/mock/form-data.mock';
import {AppFormService} from "../app-form.service";
import { values } from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { ComplaintChatComponent } from 'app/shared/components/complaint-chat.component.ts/complaint-chat.component';
import { FilesInputComponent } from 'app/shared/components/inputs/files-input/files-input.component';
import { TranslateService } from '@ngx-translate/core';
import { QuestionReportForm } from 'app/models/complaint.interface';
import { Observable, Subscription } from 'rxjs';
import { MatExpansionPanel } from '@angular/material/expansion';


@Component({
  selector: 'app-form-component',
  styleUrls: ['app-form.component.scss'],
  templateUrl: 'app-form.component.html',
})

export class AppFormComponent implements OnInit {

  @Input()
  readonly: boolean;

  public QUESTION_TYPES = QUESTION_TYPES;
  
  public form: FormGroup;
  parameters: {[questionId: number]: QuestionParameters};

  items: PosibleAnswer[] = createMockPosibleAnswes();

  tableConfig: TableInputConfig = createMockTableConfig();

  mockAnswers = createMockAnswers();

  @Input() formData: Form = createMockForm();

  @Input() onContinueObservable: Observable<void>;

  @ViewChildren(MatExpansionPanel) private panels: QueryList<MatExpansionPanel>;
  
  private onContinueSuscription: Subscription;

  public comments:  {id: number, comments: {isNew:boolean, comment: string}[] }[] = [];
  public uploadQuestionAttachmentEndpoint: string;

  formQuestionsGroups: FormQuestionGroups[] = [];

  public questionsAndGroups = [];

  getSerializedValues(): QuestionReportForm[] {
    
    return Object.entries(this.form.value as {[key: number]: QuestionData<any>})
      .map(([key, value]) => {

        return {
          id: value.answerId,
          answer: JSON.stringify({value: value.answer}),
          comments: 
            this.comments?.find(c => c.id.toString() == key)?.comments.filter(c => c.isNew).map(c => c.comment) || null, /* value.comments : null */
          attachments: this.form.get(`${key}`).dirty ? value.attachments : null, // value.attachments
          questionId: key as any as number,
          // calculatedValue: null,
        };
      });
  }

  constructor(
    private config: ConfigsLoaderService,
    private appFormService: AppFormService,
    private translate: TranslateService,
    private dialogs: MatDialog,
    private cd: ChangeDetectorRef,
  ) {
    this.uploadQuestionAttachmentEndpoint = `File/UploadFileFormTemplateAnswer`;
  }

  ngOnInit() {
    ({form: this.form, params: this.parameters} = this.appFormService.getFormAndParams(this.formData));
    if (this.readonly) {
      this.form.disable();
    }

    Object.entries(this.form.value as {[key: number]: QuestionData<any>})
      .map(([key, value]) => {
        this.comments.push({id: Number(key), comments: value.comments.map(c => {
          return { isNew: false, comment: c};
        })});
      });
    this.cd.detectChanges();

    this.formData.questions = this.formData.questions.sort((a, b) => (a.orderPosition > b.orderPosition) ? 1 : -1);
    
    this.formData.questions.map(q => {
      if(q.questionGroup){
        this.formQuestionsGroups.push(q.questionGroup);
      }
    });

    let hash = {};
    this.formQuestionsGroups = this.formQuestionsGroups.filter((current) => {
      let exists = !hash[current.id];
      hash[current.id] = true;
      return exists;
    });
    this.formQuestionsGroups.sort((a, b) => (a.orderPosition > b.orderPosition) ? 1 : -1);

    this.formData.questions.map(x => {
      this.questionsAndGroups?.push(x);
    });

    this.formQuestionsGroups.map(x => {
      this.questionsAndGroups?.push(x);
    });
    this.questionsAndGroups?.sort((a, b) => (a.orderPosition > b.orderPosition) ? 1 : -1);
  }

  ngAfterViewInit(){
    this.onContinueSuscription = this.onContinueObservable?.subscribe(() => {
      this.form.reset();
    });
  }

  ngOnDestroy(): void {
    this.onContinueSuscription?.unsubscribe();
  }

  openChatDialog(comments: any, id: number, question?){
    this.dialogs.open(ComplaintChatComponent, {
      disableClose: false,
      minWidth: '400px',
      width:'auto',
      maxWidth: '75vw',
      minHeight: 'auto',
      height:'auto',
      maxHeight: '75vh',
      data:{
        complaintId: null,
        editable: !this.readonly || false,
        comments: comments,
        isDialog: true
      }
    })
    .afterClosed().subscribe(value => {

      let questionComments = this.comments.find(c => c.id == id);

      if (questionComments) {
        questionComments.comments = value.map(c => {
          return { isNew: (c.id > 0) ? false : true, comment: c.comment};
        });
      } else {
        this.comments.push({id, comments: value.map(c => {
          return { isNew: (c.id > 0) ? false : true, comment: c.comment};
        })});
      }
      // console.log(questionComments.comments);      
      if(questionComments.comments.length > 0){
        this.form.controls[id].get('comments').setValue(questionComments.comments);
        question.param.commentRequired = false;
      }else{
        let founded = 0;
        question?.param?.items.map(x => {
          if(x.id == question.answer.value && x.commentsRequired){
            founded++;
          }
        });
        if(founded > 0){
          question.param.commentRequired = true;
          this.form.controls[id].get('comments').setErrors({'required': true});
          // console.log(this.form.controls[id].get('comments'));
        }
      }
      // else{
      //   this.form.controls[id].get('comments').setValue([''])
      // }
      this.form.get(`${id}`).markAsDirty();
    });
  }
  checkForm(){
    for (let element of this.formData.questions) {
      if(this.form.controls[element.id].invalid){
        const itemToScrollTo = document.getElementById(this.parameters[element.id].tag);
        if (itemToScrollTo) {
          this.panels.map(x => {
            x.open();
          });
          itemToScrollTo.scrollIntoView();
        }
        break
      }
    }
  }

  openAttachmentsDialog(attachments: FileDto[], question) {
    // console.log(question);

    this.dialogs.open(FilesInputComponent, {
      disableClose: false,
      width:'55vw',
      height:'55vh',
      data:{
        initialData: attachments,
        allowedExtensions: '.doc,.DOC,.docx,.DOCX,.xml,.XML,.odt,.ODT,.pdf,.PDF,.rtf,.RTF,.txt,.TXT,.wpd,.WPD,.jpg,.JPG,.png,.PNG,.7z,.7Z,.rar,.RAR,.zip,.ZIP,.csv,.CSV,.bmp,.BMP,.svg,.SVG,.tif,.TIF,.tiff,.TIFF,.ods,.ODS,.xls,.XLS,.xlsm,.XLSM,.xlsx,.XLSX,.mp4,.MP4,.mp3,.MP3,.m4a,.M4A,.msg,.MSG,.ogg,.OGG,.opus,.OPUS,.pptx,.PPTX,.eml,.EML,.aac,.AAC,.gif,.GIF,.jpeg,.JPEG',
        uploadEndpoint: 'File/UploadFileFormAttachment',
        readOnly: this.readonly,
        label: this.translate.instant('DIALOGS.TITLES.ATTACHMENTS')
      }
    })
    .afterClosed().subscribe(updatedAttachments => {
      this.setQuestionAttachments(question, updatedAttachments);
      // console.log(this.getSerializedValues());
    });

  }


  setQuestionAttachments(question, attachment){
    question.setAttachments(attachment);
    this.form.get(`${question.appQuestion.id}`).markAsDirty();
  }

  setCommentListRequired(event, question, item){
    if(event){
      question.commentRequired = true;
      item.commentRequired = true;
      this.form.controls[item.id].get('comments').setErrors({'required': true});
    }else{
      question.commentRequired = false;
      this.form.controls[item.id].get('comments').setErrors({'required': null});
      this.form.controls[item.id].get('comments').updateValueAndValidity();
    }
  }

}
